import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatChipListbox, MatChip } from '@angular/material/chips';
import { MatTooltip } from '@angular/material/tooltip';

export type CopyDateSequenceStatus = 'created' | 'updated' | 'finished' | 'removed';

export interface CopyDateSequenceWarning {
  status?: CopyDateSequenceStatus;
  message?: string;
  doubleBooking?: boolean;
  blockingDoubleBooking?: boolean;
  exception?: boolean;
  allPlannersUnavailable?: boolean;
}

export interface DialogData {
  type: 'ride' | 'daypart';
  dateSequence: string[];
  warnings: Record<string, CopyDateSequenceWarning>;
}

@Component({
  selector: 'app-copy-date-sequence',
  templateUrl: './copy-date-sequence.component.html',
  styleUrl: './copy-date-sequence.component.scss',
  imports: [
    MatDialogTitle,
    CdkDrag,
    CdkDragHandle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    MatChipListbox,
    MatChip,
    MatTooltip,
  ],
})
export class CopyDateSequenceComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CopyDateSequenceComponent>,
  ) {}

  hasWarning(dateString: string) {
    const warning = this.data.warnings[dateString];
    if (!warning) return false;
    return warning.doubleBooking === true || warning.exception === true;
  }

  hasDaypartStatus(dateString: string, status: string) {
    return this.data.type === 'daypart' && this.data.warnings[dateString]?.status === status;
  }
}
